module.exports = __webpack_public_path__ + "img/title-bg.277caf91.png";